import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const milestoneTrackingApi = createApi({
  baseQuery,
  reducerPath: 'milestoneTrackingApi',
  endpoints: builder => ({
    getMilestoneTrackingData: builder.query<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        tmfDocLevel,
        application,
        application_section,
        application_module_section = 'MILESTONE TRACKING'
      }) => ({
        url: `${formatString(
          endPoints.MileStone.getAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&tmf_doc_level=${tmfDocLevel}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateMilestoneDataStatus: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, application_section }) => ({
        url: `${formatString(
          endPoints.MileStone.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=${application_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getMilestoneGanttChartData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, application_section }) => ({
        url: `${formatString(
          endPoints.MileStone.ganttChartGetAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=${application_section}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getMilestoneAuditFilterData: builder.mutation<any, any>({
      query: ({
        audit_module_section,
        row_id,
        site_id,
        study_id,
        country,
        application,
        isOnlyUpdate,
        startFrom,
        maxSize,
        sortbyColumn,
        sortOrder,
        data,
        application_section
      }) => ({
        url: `${formatString(
          endPoints.MileStone.milstoneAuditFilterGetAll,
          { key: urlKeys.audit_module_section, value: audit_module_section },
          { key: urlKeys.row_id, value: row_id }
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&only_update=${isOnlyUpdate}&from=${startFrom}&size=${maxSize}&sort_by=${sortbyColumn}&sort_order=${sortOrder}&application_section=${application_section}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateMilestoneByMilestoneId: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, milestone_id, application_section }) => ({
        url: `${formatString(endPoints.MileStone.milestoneUpdate, {
          key: urlKeys.milestone_id,
          value: milestone_id
        })}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}&application_module_section=MILESTONE%20TRACKING`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateMilestoneActualDatesByMilestoneId: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, milestone_id, application_section }) => ({
        url: `${formatString(
          endPoints.MileStone.updateActualDates,
          {
            key: urlKeys.milestone_id,
            value: milestone_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          },
          {
            key: urlKeys.study_id,
            value: study_id
          }
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}&application_module_section=MILESTONE%20TRACKING`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),

    getMilestoneProgresData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, major_milestone, application_section }) => ({
        url: `${formatString(
          endPoints.MileStone.milestoneProgressSelect,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&majorMilestone=${major_milestone}&application_section=${application_section}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),

    updateMilestoneStartPlannedDates: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, milestone_id, application_section }) => ({
        url: `${formatString(endPoints.MileStone.updateStartPlannedDates, {
          key: urlKeys.milestone_id,
          value: milestone_id
        })}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateMilestoneEndPlannedDates: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, milestone_id, application_section }) => ({
        url: `${formatString(endPoints.MileStone.updateEndPlannedDates, {
          key: urlKeys.milestone_id,
          value: milestone_id
        })}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    ActivateMilestones: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, milestone_id, application_section }) => ({
        url: `${formatString(
          endPoints.MileStone.Activate,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    ReactivateMilestones: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, milestone_id, application_section }) => ({
        url: `${formatString(endPoints.MileStone.Reactivate, {
          key: urlKeys.milestone_id,
          value: milestone_id
        })}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=${application}&application_section=${application_section}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const {
  useLazyGetMilestoneTrackingDataQuery,
  useUpdateMilestoneDataStatusMutation,
  useLazyGetMilestoneGanttChartDataQuery,
  useGetMilestoneAuditFilterDataMutation,
  useUpdateMilestoneByMilestoneIdMutation,
  useLazyGetMilestoneProgresDataQuery,
  useUpdateMilestoneStartPlannedDatesMutation,
  useUpdateMilestoneEndPlannedDatesMutation,
  useActivateMilestonesMutation,
  useReactivateMilestonesMutation,
  useUpdateMilestoneActualDatesByMilestoneIdMutation
} = milestoneTrackingApi;
